function isLocalhost(){
    return window.location.href.startsWith("http://localhost");
}

export const apiServer = isLocalhost() ? 'http://localhost:5000/api' : 'https://rockart.herokuapp.com/api';